/**
 * POPA API.
 */

import { POPATypes } from './types.d';

const { REACT_APP_AUTH_BASE_URL } = process.env;

function getRedirectToLogin(): string {
  const frontendCallback = encodeURIComponent(window.location.origin + '/login');
  return `${REACT_APP_AUTH_BASE_URL}/login?client=superadmin&platform=web&frontendCallback=${frontendCallback}`;
}

function getLogoutUrl(): string {
  return `${REACT_APP_AUTH_BASE_URL}/logout?frontendCallback=${encodeURIComponent(
    window.location.origin
  )}`;
}

async function getRedirectToLogout(idToken?: string) {
  const frontendCallback = encodeURIComponent(window.location.origin);
  const res = await fetch(`${REACT_APP_AUTH_BASE_URL}/logout`, {
    method: 'POST',
    body: JSON.stringify({
      idToken,
      frontendCallback,
    }),
  });

  const data = await res.json();
  return data.logoutUrl;
}

async function getTokensFromTempToken(accessKey: string): Promise<POPATypes.TokensResponseData> {
  const res = await fetch(`${REACT_APP_AUTH_BASE_URL}/tokens`, {
    body: JSON.stringify({
      client: 'superadmin',
      platform: 'web',
      code: accessKey,
    }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  const data = await res.json();

  if (!res.ok) {
    const error = new Error(data.error);
    error.cause = data;
    throw error;
  }

  return data;
}

async function getFullLoginByTokens(
  accessToken: string,
  refreshToken: string
): Promise<POPATypes.TokensResponseData> {
  const res = await fetch(`${REACT_APP_AUTH_BASE_URL}/refresh`, {
    body: JSON.stringify({
      accessToken,
      refreshToken,
    }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  const data = await res.json();

  if (!res.ok) {
    const error = new Error(data.error);
    error.cause = data;
    throw error;
  }
  return data;
}

const POPA = {
  getRedirectToLogin,
  getLogoutUrl,
  getRedirectToLogout,
  getTokensFromTempToken,
  getFullLoginByTokens,
};

export default POPA;
